const features = [
  {
    icon: 'ri-lock-password-line',
    title: 'Military-Grade Encryption',
    desc: '256-bit AES encryption ensures your data is unreadable to any third party, keeping your personal information completely secure.',
    detail: 'VPN Security',
    sub: 'AES-256 Protocol',
  },
  {
    icon: 'ri-delete-bin-6-line',
    title: 'One-Tap Cleaning',
    desc: 'Instantly clear junk files, cache, and temporary data with a single tap — freeing up storage without any technical knowledge needed.',
    detail: 'Cleaner Engine',
    sub: 'Smart Detection',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'No-Log Policy',
    desc: 'We never record your browsing activity, connection logs, or any identifiable data. Your digital footprint stays yours alone.',
    detail: 'Privacy Policy',
    sub: 'Zero Logging',
  },
  {
    icon: 'ri-pie-chart-2-line',
    title: 'Smart Storage Analysis',
    desc: 'Visual breakdowns of what is consuming your storage make it easy to identify and remove the biggest offenders instantly.',
    detail: 'Storage AI',
    sub: 'Real-time Scan',
  },
  {
    icon: 'ri-global-line',
    title: 'Global Server Network',
    desc: 'Connect to servers across dozens of countries for fast, reliable encrypted browsing — regardless of your location.',
    detail: 'VPN Network',
    sub: '50+ Countries',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Junk File Detection',
    desc: 'Advanced algorithms intelligently identify and categorize junk files, duplicate photos, and oversized attachments for easy cleanup.',
    detail: 'Cleaner AI',
    sub: 'Auto Detection',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-[#F8F8F8] py-36">
      <div className="max-w-[1400px] mx-auto px-16">
        {/* Header */}
        <div className="text-center mb-20 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-2 h-2 rounded-full bg-[#D4FF00]" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8A8A8A]">Features</span>
            <div className="w-2 h-2 rounded-full bg-[#D4FF00]" />
          </div>
          <h2 className="text-[56px] font-bold text-[#1A1A1A] leading-[1.1] mb-6">
            Why Choose Our<br />
            <span className="italic font-light">Applications</span>
          </h2>
          <p className="text-[#7A7A7A] text-lg leading-relaxed">
            Designed with user experience and security in mind — every feature
            exists to make your iOS device safer and smarter.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-white rounded-2xl p-8 border border-[#EDEDED] hover:border-[#D4FF00] transition-colors duration-300 group"
            >
              {/* Dots */}
              <div className="flex gap-1.5 mb-6">
                {[...Array(5)].map((_, i) => (
                  <div
                    key={i}
                    className="w-2 h-2 rounded-full transition-all duration-300"
                    style={{ backgroundColor: i < 3 ? '#D4FF00' : '#E8E8E8' }}
                  />
                ))}
              </div>

              {/* Title & desc */}
              <h3 className="text-xl font-semibold text-[#1A1A1A] mb-3 leading-tight">{f.title}</h3>
              <p className="text-[#7A7A7A] text-sm leading-relaxed mb-8">{f.desc}</p>

              {/* Bottom icon row */}
              <div className="flex items-center gap-3 pt-6 border-t border-[#F0F0F0]">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#F4F4F4] group-hover:bg-[#D4FF00]/20 transition-colors duration-300">
                  <i className={`${f.icon} text-lg text-[#1A1A1A]`} />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#1A1A1A]">{f.detail}</p>
                  <p className="text-xs text-[#9A9A9A]">{f.sub}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
